import { FETCH_SEARCH_SUCCESS } from 'Catalog/Search/ducks'

export default (state = {}, action) => {
  let hotServices = {}

  switch (action.type) {
    case FETCH_SEARCH_SUCCESS:
      const services = action.payload.data.services || []
      hotServices = services.reduce(
        (services, currentProduct) => {
          const {
            image,
            name,
            partner,
            partnerId,
            path
          } = currentProduct

          return {
            ...services,
            [name]: {
              ...state[name],
              image,
              name,
              partner,
              partnerId,
              path
            }
          }
        },
        {}
      )
      return { ...state, ...hotServices }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/Catalog/Service/ducks.js